export default "__VITE_ASSET__CsVkw0De__"